export default __webpack_public_path__ + "static/media/logo-outlined.1ac4bf64.svg";